import type {PayloadAction} from '@reduxjs/toolkit';

import {createSlice} from '@reduxjs/toolkit';

import {builderBranches, builderGetBestSelling} from './reducer';

const initialState: any = {
  branches: [] as any[] as any[],
  profile: {},
  profileId: undefined,
  loadingBranches: false,
  getBranchesError: '',
  getBranchesSuccess: false,
  branchesPagination: {},
  getBranchesPage: 0,
  selectedVendor: undefined as any as any,
  BestSellingData: undefined,
  loadingBestSelling: false,
  BestSellingError: '',
  showVendorToast: true
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateShowVendorToast: (state: any, action: PayloadAction<boolean>) => {
      state.showVendorToast = action.payload;
    },
    setSelectedVendor: (state: any, action: any) => {
      if (action.payload == null) {
        localStorage.removeItem('selectedVendor');
      } else {
        localStorage.setItem('selectedVendor', JSON.stringify(action.payload));
      }
      state.selectedVendor = action.payload;
    },

    updateBranches: (state: any, action: any) => {
      const vendor = action.payload;
      const array: any[] = [];
      state.branches.forEach((branch) => {
        if (branch.id === vendor.id) {
          array.push({
            ...vendor,
            attributes: {
              ...vendor.attributes,
              isActive: !vendor.attributes.isActive
            }
          });
        } else {
          array.push(branch);
        }
      });
      state.branches = array;
      const selectedVendor = {
        ...vendor,
        attributes: {
          ...vendor?.attributes,
          isActive: !vendor?.attributes?.isActive
        }
      };
      localStorage.setItem('selectedVendor', JSON.stringify(selectedVendor));
      state.selectedVendor = selectedVendor;
    },
    resetBranches: (state: any) => {
      state.branches = [];
      state.getBranchesPage = 0;
    },
    updateGetBranchesPage: (state: any, action: PayloadAction<number>) => {
      state.getBranchesPage = action.payload;
    }
  },
  extraReducers: (builder) => {
    //get branches
    builderBranches(builder);

    //get best selling
    builderGetBestSelling(builder);
  }
});

export const {
  setSelectedVendor,
  updateBranches,
  resetBranches,
  updateShowVendorToast,
  updateGetBranchesPage
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
